import { InjectionToken } from '@angular/core';

/**
 * Interface for providing current marina ID
 */
export interface IMarinaIdProvider {
  getCurrentMarinaId(): string | null;
}

/**
 * Injection token for marina ID provider
 */
export const MARINA_ID_PROVIDER = new InjectionToken<IMarinaIdProvider>('MARINA_ID_PROVIDER');

